import { Fragment, useEffect, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useFormContext } from "react-hook-form";
import { classNames } from "../utils/formatters";
import { PROVINCES } from "../utils/constants";

export default function MunicipalitySelect({
  name,
  value,
  onChange,
  disabled,
  provinceField,
}) {
  const { formState, watch, setValue } = useFormContext(); // retrieve all hook methods
  const { errors } = formState;
  const province = watch(provinceField || "province");
  const [prevProvince, setPrevProvince] = useState(province);
  const municipalities =
    PROVINCES[province?.id || province]?.municipalities || [];

  // const [selected, setSelected] = useState(null);
  const [query, setQuery] = useState("");
  const selected = value;

  useEffect(() => {
    if (prevProvince && province.id !== prevProvince.id) {
      setValue(name, null);
    }
    setPrevProvince(province);
  }, [province]);

  const filteredMunicipalities =
    query === ""
      ? municipalities
      : municipalities.filter((municipality) =>
          municipality
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <div className="">
      <label
        htmlFor="municipality"
        className="block text-sm font-medium text-gray-700"
      >
        Cantón
      </label>
      <Combobox
        value={selected}
        onChange={onChange}
        disabled={disabled || !province}
      >
        <div className="relative mt-1">
          <div
            className={classNames(
              "relative w-full cursor-default overflow-hidden rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500 block border border-gray-300 sm:text-sm",
              errors[name]
                ? "ring-2 ring-red-500 ring-offset-2 ring-offset-white"
                : ""
            )}
          >
            <Combobox.Button as="div">
              <Combobox.Input
                className={classNames(
                  "w-full border-none py-2 pl-3 pr-10 text-input leading-5 text-gray-900 focus:ring-0 normal-case",
                  disabled ? "bg-gray-100" : ""
                )}
                displayValue={(municipality: string) => municipality || ""} //there should be a better fix
                onChange={(event) => setQuery(event.target.value)}
              />
              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </Combobox.Button>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10">
              {filteredMunicipalities.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                  Cantón no encontrada.
                </div>
              ) : (
                filteredMunicipalities.map((municipality) => (
                  <Combobox.Option
                    key={municipality}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 px-4 ${
                        active ? "bg-orange-500 text-white" : "text-gray-900"
                      }`
                    }
                    value={municipality}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {municipality}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 right-0 flex items-center pr-3 ${
                              active ? "text-white" : "text-orange-500"
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
